<template>
  <el-radio-group
    class="ARadioGroup inline" 
    v-model="val"     
    size="mini"       
    @change="change">
    <el-radio class="radio_item"
      v-for="item in items"
      :key="item[labelField]"
      :label="item[labelField]"
    >{{ item[valueField] }}</el-radio> 
  </el-radio-group>
</template>
<script>
import { selector } from "@/common/mixins/selector";

export default {
  name: "ARadioGroup",
  mixins: [selector],
  props: {
    items: {
      default: [],
    },    
    labelField: {
      type: String,
      default: 'label'
    },    
    valueField: {
      type: String,
      default: 'name'
    },
  },
};
</script>
<style lang="scss">
.el-radio__label {
	font-size: 12px;
}
</style>
